import { Button, Space, Table, Form, Input, Select } from "antd";
import Axios from "middleware/axiosInstance";
import { Link, useParams } from "react-router-dom";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
import Loading from "layouts/Loading/Loading";
import { convertToMiladi, convertToShamsi } from "utils/dateCoverter";
import { useState, useEffect } from "react";
import { Row, Col, Pagination } from "antd";
import "antd/dist/antd.css";
import useAxios from "middleware/useAxios";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Icon from "react-multi-date-picker/components/icon";

const { Option } = Select;

const WarehouseDocuments = () => {
  // start react router url params
  const UrlParams = useParams();
  const docType = UrlParams.type;
  console.log(docType);
  // end react router url params
  const serverDomain = process.env.REACT_APP_Server_Domain;

  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [data, setData] = useState([]);
  const [customizedData, setCustomizedData] = useState(null);
  const [
    valuesAndParamsOfFilteredItemsByUser,
    setValuesAndParamsOfFilteredItemsByUser,
  ] = useState({
    anbar_id: "",
    commodity_id: "",
    people_id: "",
    from_date: "",
    to_date: "",
  });
  const [form] = Form.useForm();

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const [startAndEndOfDateForFilter, setStartAndEndOfDateForFilter] =
    useState(null);
  const [responseIsInFilterMode, setResponseIsInFilterMode] = useState(false);

  const [allWarehouse] = useAxios({
    method: "get",
    url: "/anbar",
  });
  const [allPeople] = useAxios({
    method: "get",
    url: "/people",
  });

  const [allCommodity] = useAxios({
    method: "GET",
    url: "/commodity",
  });

  const changeDateAndTimeOfDocHandler = (e) => {
    console.log(e);
    const temp = [];
    if (e[0]) {
      const startDateInShamsi = `${e[0].year}-${e[0].month.number}-${e[0].day}`;
      const startDateInMiladi = convertToMiladi(startDateInShamsi);
      temp.push({ shamsi: startDateInShamsi, miladi: startDateInMiladi });
    }

    if (e[1]) {
      const endDateInShamsi = `${e[1].year}-${e[1].month.number}-${e[1].day}`;
      const endDateInMiladi = convertToMiladi(endDateInShamsi);
      temp.push({ shamsi: endDateInShamsi, miladi: endDateInMiladi });
    }
    console.log(temp);
    setStartAndEndOfDateForFilter(temp);
  };

  const handleFilterFormValuesSubmit = (e) => {
    setResponseIsInFilterMode(true);
    console.log(e);
    if (startAndEndOfDateForFilter) {
      if (startAndEndOfDateForFilter[0]) {
        e.from_date = startAndEndOfDateForFilter[0].miladi;
        console.log(e.from_date);
      }
      if (startAndEndOfDateForFilter[1]) {
        e.to_date = startAndEndOfDateForFilter[1].miladi;
      }
    }
    setValuesAndParamsOfFilteredItemsByUser(e);
    console.log(e);
    Axios.post(docType === "entry" ? "/import_report" : "/export_report", e)
      .then((res) => {
        setData(res.data);
        if (res.data[0]) {
          const temp = res.data.map((item) => {
            const type = docType === "entry" ? "import" : "export";
            return {
              ...item,
              // key is for expanded Row
              key: item.id,
              people: {
                name: item.name,
                family: item.family,
              },
              // agar filter bar ruye kala (commodity) ham bashad,
              // format ersal motafavet ast va items ra dakhele import darim, pas bayad items ra ijad konim
              ...(item.items === undefined && {
                items: item[type].items,
              }),
            };
          });
          console.log(temp);
          setCustomizedData(temp);
        } else {
          // alert("چیزی پیدا نشد");
          setCustomizedData([]);
        }
      })
      .catch((err) => console.log(err));
  };

  const downloadExcelFileOfFilteredFields = () => {
    window.location.href = `${serverDomain}/api${
      docType === "entry" ? "/import" : "/export"
    }_download?anbar_id=${
      valuesAndParamsOfFilteredItemsByUser.anbar_id || ""
    }&commodity_id=${
      valuesAndParamsOfFilteredItemsByUser.commodity_id || ""
    }&people_id=${
      valuesAndParamsOfFilteredItemsByUser.people_id || ""
    }&from_date=${
      valuesAndParamsOfFilteredItemsByUser.from_date || ""
    }&to_date=${valuesAndParamsOfFilteredItemsByUser.to_date || ""}`;
  };

  const getAllDocs = () => {
    Axios.get(docType === "entry" ? "/import" : "/export")
      .then((res) => {
        setData(res.data);
        console.log(res.data.data);
        const temp = res.data.data.map((item) => {
          // *****-----++++++ Antd table data must have a key in data for use in each table row +++++ ----- ******
          return {
            ...item,
            key: item.id,
          };
        });
        console.log(temp);
        setCustomizedData(temp);
      })
      .catch((err) => console.log(err));
  };

  const clearFilters = () => {
    setFilteredInfo({});
  };

  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  const deleteDoc = (item) => {
    if (window.confirm(`آیا سند "${item.sh_sanad}" حذف گردد؟`)) {
      deleteDocHandler(item);
    }
  };

  const deleteDocHandler = (item) => {
    Axios.delete(`${docType === "entry" ? "/import" : "/export"}/${item.id}`)
      .then((res) => {
        if (res.status === 204) {
          console.log(res);
          OpenNotificationWithIcon("حذف موفق", "حذف سند با موفقیت انجام شد");
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        getAllDocs();
      });
  };

  useEffect(() => {
    setCustomizedData(null);
    getAllDocs();
    form.resetFields();
    setStartAndEndOfDateForFilter(null);
  }, [docType]);

  const columns = [
    {
      title: "شماره سند",
      dataIndex: "id",
      key: "id",
      // item.ID baraye zamani hast ke filter bar ruye kala bashe, pas id bargardunde shode ba id sanad motafavet hast
      // vase hamin age ID bud ID ro migire vase joziiat age na id      render: (_, item) => <span>{item.ID || item.id}</span>,
      sorter: (a, b) => (a.id > b.id ? 1 : b.id > a.id ? -1 : 0),
      sortOrder: sortedInfo.columnKey === "id" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "تاریخ سند",
      dataIndex: "date",
      key: "date",
      render: (date) => (
        <span>
          {/* {moment(`${date}`, "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD")} */}
          {responseIsInFilterMode ? convertToShamsi(date) : date}
        </span>
      ),

      sorter: (a, b) => (a.date > b.date ? 1 : b.date > a.date ? -1 : 0),
      sortOrder: sortedInfo.columnKey === "date" ? sortedInfo.order : null,
    },
    {
      title: "نام شخص",
      dataIndex: "people",
      key: "people",
      render: (_, item) => (
        <span>{item.people?.name + " " + item.people?.family}</span>
      ),
      // ++++++++
      // ________
      // *************  -------   by data.filter we get unique objects from
      // *************  -------   arra because array has duplicated People name
      // data.filter((v, i, a) => a.findIndex(v2 => (v2.people.name === v.people.name)) === i)
      // ________
      // ++++++++

      // filters: data
      //   .filter(
      //     (v, i, a) => a.findIndex((v2) => v2.people?.id === v.people?.id) === i
      //   )
      //   .map((item) => {
      //     return {
      //       text: item.people.name + " " + item.people.family,
      //       value: item.people.name + " " + item.people.family,
      //     };
      //   }),
      // filterMultiple: false,

      // filteredValue: filteredInfo.people || null,
      // onFilter: (value, record) =>
      //   (record.people.name + " " + record.people.family).includes(value),
      // onFilter: (value, record) => record.people?.id.includes(value),
      // onFilter: (value, record) => console.log("value", value, record.people.id),

      sorter: (a, b) =>
        a.people.name > b.people.name
          ? 1
          : b.people.name > a.people.name
          ? -1
          : 0,
      sortOrder: sortedInfo.columnKey === "people" ? sortedInfo.order : null,
      ellipsis: true,
      // sorter: (a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0),
      // sortOrder: sortedInfo.columnKey === "people" ? sortedInfo.order : null,
    },
    {
      title: "نوع سند",
      dataIndex: "is_trust",
      key: "is_trust",
      sorter: (a, b) => (a.id > b.id ? 1 : b.id > a.id ? -1 : 0),
      sortOrder: sortedInfo.columnKey === "is_trust" ? sortedInfo.order : null,
      ellipsis: true,
      render: (a, item) => (
        <span>
          {item.import
            ? item.import.is_trust === 1
              ? "امانی"
              : "قطعی"
            : item.export
            ? item.export.is_trust === 1
              ? "امانی"
              : "قطعی"
            : item.is_trust === 1
            ? "امانی"
            : "قطعی"}
        </span>
      ),
    },

    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      render: (a, item) => (
        <Space size="small">
          <Link
            to={`/warehouse/edit-warehouse-document/${
              docType === "entry" ? "entry" : "exit"
            }?DocId=${item.id}`}
            className="btn btn-primary btn-sm"
          >
            ویرایش
          </Link>
          <Link
            to={`/warehouse/warehouse-document-details/${
              docType === "entry" ? "entry" : "exit"
              // item.ID baraye zamani hast ke filter bar ruye kala bashe, pas id bargardunde shode ba id sanad motafavet hast
              // vase hamin age ID bud ID ro migire vase joziiat age na id
            }?DocId=${item.ID || item.id}`}
            className="btn btn-success btn-sm"
          >
            جزییات
          </Link>
          {/* {docType === "entry" && (
            <Link
              to={`/warehouse/warehouse-convert?anbarId=${item.anbar_id}&DocId=${item.id}`}
              className="btn btn-success btn-sm"
            >
              تبدیل
            </Link>
          )} */}
          <button
            onClick={() => deleteDoc(item)}
            className="btn btn-danger btn-sm"
          >
            حذف
          </button>
        </Space>
      ),
    },
  ];

  const changePageHandler = (page) => {
    console.log(page);
    Axios.get(
      docType === "entry" ? `/import?page=${page}` : `/export?page=${page}`
    )
      .then((res) => {
        setData(res.data);
        const temp = res.data.data.map((item) => {
          // ***** ----- +++++ Antd table data must have a key in data for use in each table row +++++ ----- ******
          return {
            ...item,
            key: item.id,
          };
        });
        setCustomizedData(temp);
      })
      .catch((err) => console.log(err));
  };

  // 0000000000000000000000  start extended row  0000000000000000000000
  const expandedRowRender = (row, index) => {
    const columns = [
      {
        title: "نام کالا",
        dataIndex: "item",
        key: "item",
        render: (row, item) =>
          docType === "entry"
            ? item.commodity?.name
            : item.second_commodity?.name,
      },
      {
        title: "مقدار",
        dataIndex: docType === "entry" ? "count_im" : "count_ex",
        key: docType === "entry" ? "count_im" : "count_ex",
      },
      {
        title: "موجودی در انبار بعد از ثبت حواله",
        dataIndex: "current_count",
        key: "current_count",
      },
    ];
    const data = customizedData[index].items;

    return <Table columns={columns} dataSource={data} pagination={false} />;
  };

  // 0000000000000000000000  end extended row  0000000000000000000000
  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">
          {docType === "entry"
            ? "اسناد ورودی به انبار"
            : "اسناد خروجی از انبار"}
        </h5>

        <Form
          layout="vertical"
          form={form}
          autoComplete="off"
          scrollToFirstError
          labelCol={{ xs: 24 }}
          onFinish={handleFilterFormValuesSubmit}
        >
          <Row gutter={8}>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label={docType === "entry" ? "انبار ورود" : "انبار خروج"}
                name="anbar_id"
              >
                <Select
                  loading={!allWarehouse?.[0]}
                  fieldNames="anbar_id"
                  placeholder="انتخاب فرمایید"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  id="anbar_id"
                >
                  {allWarehouse?.map((wareHouse) => {
                    return (
                      <Option key={wareHouse.id} value={wareHouse.id}>
                        {wareHouse.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="تاریخ"
                name="date"
                rules={[
                  {
                    required: false,
                    message: "انتخاب بازه زمانی الزامی می باشد",
                  },
                  () => ({
                    validator(_, value) {
                      if (
                        startAndEndOfDateForFilter?.[0] &&
                        startAndEndOfDateForFilter?.[1] === undefined
                      ) {
                        return Promise.reject("تاریخ پایان اجباری");
                      } else return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input
                  disabled
                  placeholder={
                    startAndEndOfDateForFilter?.[0] &&
                    startAndEndOfDateForFilter?.[1]
                      ? ` ${startAndEndOfDateForFilter[0]?.shamsi} - ${startAndEndOfDateForFilter[1]?.shamsi} `
                      : "انتخاب تاریخ"
                  }
                  addonBefore={
                    <DatePicker
                      // value={newWarehouseEntryDocument.date}
                      onChange={(e) => changeDateAndTimeOfDocHandler(e)}
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-left"
                      range
                      render={
                        <Icon
                          style={{
                            color: "gray",
                            width: "23px",
                          }}
                        />
                      }
                    />
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item label="شخص" name="people_id">
                <Select
                  loading={!allPeople?.[0]}
                  showSearch
                  fieldNames="people_id"
                  placeholder="انتخاب فرمایید"
                  optpionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  id="people_id"
                >
                  {allPeople?.map((people) => {
                    return (
                      <Option key={people.id} value={people.id}>
                        {`${people.name} ${people.family}`}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item label="شخص دوم" name="people2_id">
                <Select
                  loading={!allPeople?.[0]}
                  showSearch
                  fieldNames="people2_id"
                  placeholder="انتخاب فرمایید"
                  optpionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  id="people2_id"
                >
                  {allPeople?.map((people) => {
                    return (
                      <Option key={people.id} value={people.id}>
                        {`${people.name} ${people.family}`}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item name={"commodity_id"} label="شناسه/نام کالا">
                <Select
                  showSearch
                  loading={!allCommodity?.[0]}
                  placeholder="انتخاب فرمایید"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                >
                  {allCommodity?.map((kala) => {
                    return (
                      <Option key={kala.id} value={kala.id}>
                        {`${kala.id} -${kala.name}`}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item name={"is_trust"} label="نوع سند">
                <Select
                  showSearch
                  placeholder="انتخاب فرمایید"
                  optionFilterProp="children"
                >
                  <Option value={true}>امانی</Option>
                  <Option value={false}>قطعی</Option>
                  <Option value="null">تمام موارد</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={8}>
            <Space>
              <Form.Item>
                <Button htmlType="submit" type="primary">
                  جستجو
                </Button>
              </Form.Item>
              <Form.Item>
                <Button
                  htmlType="button"
                  type="primary"
                  onClick={() => {
                    form.resetFields();
                    setStartAndEndOfDateForFilter(null);
                    setValuesAndParamsOfFilteredItemsByUser({
                      anbar_id: "",
                      commodity_id: "",
                      people_id: "",
                      from_date: "",
                      to_date: "",
                    });
                    getAllDocs();
                  }}
                >
                  حذف فیلترها
                </Button>
              </Form.Item>
              <Form.Item>
                <Button
                  htmlType="button"
                  type="primary"
                  onClick={downloadExcelFileOfFilteredFields}
                >
                  دانلود فایل Excel
                </Button>
              </Form.Item>
            </Space>
          </Row>
        </Form>
        {customizedData ? (
          <>
            <Table
              pagination={false}
              columns={columns}
              dataSource={customizedData}
              rowKey={customizedData.id}
              onChange={handleChange}
              expandable={{
                expandedRowRender,
                defaultExpandedRowKeys: ["0"],
              }}
            />
            <div className="d-flex justify-content-center align-items-center w-100 mt-3">
              <Pagination
                onChange={(page) => changePageHandler(page)}
                defaultCurrent={1}
                pageSize={data.per_page}
                total={data.total}
                showSizeChanger={false}
              />
            </div>
          </>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
};
export default WarehouseDocuments;
